module.exports = __webpack_public_path__ + "img/infrastructure-4.c35ac321.png";